import { render, staticRenderFns } from "./RiskAnalysisForm.vue?vue&type=template&id=b7b8e95c"
import script from "./RiskAnalysisForm.vue?vue&type=script&lang=js"
export * from "./RiskAnalysisForm.vue?vue&type=script&lang=js"
import style0 from "./RiskAnalysisForm.vue?vue&type=style&index=0&id=b7b8e95c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports